module.exports = __webpack_public_path__ + "static/media/page-monster-wally.2d13fa30.png";